import { Button, Checkbox } from '@mantine/core';
import { useTranslation } from '../context/TranslationContext';

export default function AddressForm({ form, onChange, onSubmit, loading, saving, type, extraFields, children }) {
  const { t } = useTranslation();
  const formId = type === 'Shipping' ? 'shipping-address-form' : 'billing-address-form';
  const saveLabel = type === 'Shipping' ? t('saveShippingAddress', 'Save Shipping Address') : t('saveBilling', 'Save Billing Address');
  return (
    <form id={formId} onSubmit={onSubmit} className="shipping-form">
      {children}
      <div className="form-grid">
        <label htmlFor={`${formId}-full-name`} className="sr-only">{t('fullName', 'Full name')}</label>
        <input
          id={`${formId}-full-name`}
          name="full_name"
          placeholder={t('fullName', 'Full name')}
          value={form.full_name}
          onChange={onChange}
          required
          autoComplete="name"
        />
        {extraFields}
        <label htmlFor={`${formId}-line1`} className="sr-only">{t('addressLine1', 'Address line 1')}</label>
        <input
          id={`${formId}-line1`}
          name="address_line1"
          placeholder={t('addressLine1', 'Address line 1')}
          value={form.address_line1}
          onChange={onChange}
          required
          autoComplete="address-line1"
        />
        <label htmlFor={`${formId}-line2`} className="sr-only">{t('addressLine2Optional', 'Address line 2 (optional)')}</label>
        <input
          id={`${formId}-line2`}
          name="address_line2"
          placeholder={t('addressLine2Optional', 'Address line 2 (optional)')}
          value={form.address_line2}
          onChange={onChange}
          autoComplete="address-line2"
        />
        <label htmlFor={`${formId}-city`} className="sr-only">{t('city', 'City')}</label>
        <input
          id={`${formId}-city`}
          name="city"
          placeholder={t('city', 'City')}
          value={form.city}
          onChange={onChange}
          required
          autoComplete="address-level2"
        />
        <label htmlFor={`${formId}-postal`} className="sr-only">{t('postalCode', 'Postal code')}</label>
        <input
          id={`${formId}-postal`}
          name="postal_code"
          placeholder={t('postalCode', 'Postal code')}
          value={form.postal_code}
          onChange={onChange}
          required
          autoComplete="postal-code"
          inputMode="numeric"
        />
        <label htmlFor={`${formId}-country`} className="sr-only">{t('country', 'Country')}</label>
        <input
          id={`${formId}-country`}
          name="country"
          placeholder={t('country', 'Country')}
          value={form.country}
          onChange={onChange}
          required
          autoComplete="country-name"
        />
      </div>
      <Checkbox
        name="is_default"
        label={t('setAsDefault', 'Set as default')}
        checked={form.is_default}
        onChange={(e) => onChange({ target: { name: 'is_default', type: 'checkbox', checked: e.currentTarget.checked } })}
      />
      <Button type="submit" loading={saving} fullWidth>{saveLabel}</Button>
    </form>
  );
}
